<template>
<div>
	<field :params="{
			type: 'boolean',
			doubleLabels: ['Grid','Columns']
		}"
		v-model="weeklySubViewColumns">
	</field>
	<table v-if="weeklySubViewColumns" class="weekly-view">
		<thead>
			<tr class="days-axis">
				<th v-for="d in week" class="day"
					:class="{'weekend-day': d.format('dd') == 'Su' || d.format('dd') == 'Sa'}"
					v-on:click="dayClick(d)">
					<div class="day-of-week">{{ d.format("ddd") }}</div>
					<div class="date">{{ d.format("MMM D") }}</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<draggable v-for="(d,dayIndex) in week" 
					:class="gridViewDraggableClasses(d)" 
					style="vertical-align: top;" 
					tag="td"
					group="items"
					v-model="eventDayVModels[dayIndex]"
					v-on:end="dragEnd($event,filteredEventsSortedByPriority.filter(item => item.startMoment.format('dd') == d.format('dd')),dayIndex)">
					
					<schedule-item v-for="item in eventDayVModels[dayIndex]"
						v-on:itemClick="itemClick(item)"
						:item="item"
						:selected-date="selectedDate"
						:schedule-settings="scheduleSettings">
					</schedule-item>

				</draggable>
			</tr>
		</tbody>
	</table>
	<table v-else class="weekly-view">
		<thead>
			<tr class="days-axis">
				<th>Grid</th>
				<th v-for="d in week" class="day"
					:class="{'weekend-day': d.format('dd') == 'Su' || d.format('dd') == 'Sa'}"
					v-on:click="dayClick(d)">
					<div class="day-of-week">{{ d.format("ddd") }}</div>
					<div class="date">{{ d.format("MMM D") }}</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(row,rowIndex) in mergeScheduleRows(filterRenderedScheduleRows(renderScheduleRows(scheduleEvents,equipmentServicing)))"
				class="scheduled-item-row"
					:class="{
						'project-row': row.type == 'project',
						'service-row': row.type == 'service',
						'equipment-row': row.type == 'equipment-servicing'	
					}">
				
				<th class="row-label">
					<i class="fa mr-2 ml-2" :class="typeIcon(row.type)"
						:style="{
							'color' : row.color_hex
						}">		
					</i>
					<div>
						{{ row.description }}
						<div class="text-muted">{{getHoursScheduled(row)}} hrs scheduled</div>
					</div>
				</th>
				<draggable v-for="(d,dayIndex) in week" 
					class="day-container" 
					:class="'day-of-'+d.format('YYYY-MM-DD')"
					tag="td" 
					:group="'rowItems_'+rowIndex"
					v-on:end="dragEnd($event,row.items.filter(item => item.startMoment.format('dd') == d.format('dd')),dayIndex)">

					<schedule-item v-for="item in row.items.filter(item => item.startMoment.format('dd') == d.format('dd'))"
						v-on:itemClick="itemClick(item)"
						:item="item"
						:selected-date="selectedDate"
						:schedule-settings="scheduleSettings">
					</schedule-item>
				</draggable>
			</tr>
		</tbody>
	</table>
</div>
</template>
<script type="text/javascript">

import ScheduleMixins from "@/mixins/ScheduleMixins.js"
import ScheduleItem from "@/components/schedule/ScheduleItem"

import Field from "@/components/Field"
import draggable from "vuedraggable"

export default {
	name: "WeeklyViewDraggable",
	components: {
		ScheduleItem,
		Field,
		draggable
	},
	props: [
		"selectedDate",
		"scheduleEvents",
		"equipmentServicing",
		"filtering"
	],
	mixins: [ScheduleMixins],
	data() {
		return {
			projectFiltering: false,
			serviceFiltering: false,
			equipmentFiltering: false,
			userFiltering: false,
			filters: {
				mainTypes: ["project","service","equipment","user","equipment-servicing"],
				projectIds: [],
				serviceIds: [],
				equipmentIds: [],
				userIds: []
			},
			dayWidth: 100 / 7, //in %
			labelWidth: 12.5, //in %
			weeklySubViewColumns: true,
			eventDayVModels: [],
			eventDayVModelsOldState: []
		}
	},
	watch: {
		filtering() {
			this.initFilteringValues()
		},
		'filtering.filters'() {
			this.initFilteringValues()
		},
		scheduleEvents() {
			this.setEventDayVModels()
		}
	},
	computed: {
		filteredEventsSortedByPriority() {
			let vm = this

			let projectsUserIsOn = [], servicesUserIsOn = []
				if (vm.filters.mineOnly) {
					this.scheduleEvents
						.filter(event => event.type == 'user' && event.user_id == vm.$store.userDetails.id && event.job_id > 0)
						.forEach(event => {
							projectsUserIsOn.push(event.job_id)
						})

					this.scheduleEvents
						.filter(event => event.type == 'user' && event.user_id == vm.$store.userDetails.id && event.service_id > 0)
						.forEach(event => {
							servicesUserIsOn.push(event.service_id)
						})
				}

			let events = this.eventsSortedByPriority.filter(event => {
				let entityId = event[event.entityKey]
				let relatedProjectId = false, relatedServiceId = false
				if ("job_id" in event && event.job_id > 0)
					relatedProjectId = event.job_id
				if ("service_id" in event && event.service_id > 0)
					relatedServiceId = event.service_id

				let include = true

				if (vm.filters.mainTypes.indexOf(event.type) == -1)
					return false

				if (event.type == 'project' && vm.projectFiltering && vm.filters.projectIds.length > 0)
					include = vm.filters.projectIds.find(id => id == entityId)

				if (event.type == 'service' && vm.serviceFiltering && vm.filters.serviceIds.length > 0) 
					include = vm.filters.serviceIds.find(id => id == entityId)

				if (event.type == 'user' && vm.userFiltering && vm.filters.userIds.length > 0)  
					include = vm.filters.userIds.find(id => id == entityId)

				if (vm.filters.mineOnly && include) {

					if (event.type == 'equipment-servicing')
						return false
					else if (event.type == 'user' && entityId == vm.$store.userDetails.id)
						return true

					//if event is a project, check $store.userProjectIds (jobs user has role on)
					if (event.type == 'project')
						include = vm.$store.userProjectIds.find(jobId => entityId == jobId)
					else if (event.type == 'service')
						include = vm.$store.userServiceIds.find(jobId => entityId == jobId)
					else if (relatedProjectId) 
						include = vm.$store.userProjectIds.find(jobId => relatedProjectId == jobId)
					else if (relatedServiceId) 
						include = vm.$store.userServiceIds.find(jobId => relatedServiceId == jobId)
					

					//check jobs user is scheduled on
					if (event.type == 'project') 
						include = projectsUserIsOn.find(jobId => entityId == jobId)
					
					else if (event.type == 'service') 
						include = servicesUserIsOn.find(jobId => entityId == jobId)
					
					else if (relatedProjectId) 
						include = projectsUserIsOn.find(jobId => relatedProjectId == jobId)

					else if (relatedServiceId) 
						include = servicesUserIsOn.find(jobId => relatedServiceId == jobId)
					
				}

				if (vm.filters.showOnlyRelated) {
					if (vm.serviceFiltering && (event.type == 'user' || event.type == 'equipment') && vm.filters.serviceIds.indexOf(relatedServiceId) >= 0) 
						//only include if this event is related to events in the services list
						include = true

					else if (vm.projectFiltering & (event.type == 'user' || event.type == 'equipment') && vm.filters.projectIds.indexOf(relatedProjectId) >= 0) 
						//only incldue if the this event is related to the events in the projects list
						include = true
					
					else
						include = false
				}

				if (include && vm.filters.jobCategories.length > 0) {
					if (event.type != 'employee' && event.type != 'equipment') {
						//only include if it has events with a category that matches one in the selected category filters
						let job = null
						if ("Job" in event && event.Job)
							job = event.Job
						else if ("Service" in event && event.Service)
							job = event.Service

						if (job) {
							if (vm.filters.jobCategories.indexOf(job.category_id) >= 0)
								include = true
							else include = false
						}
					}
				}

				return include
			})

			console.log(events)

			return events
		},
		eventsSortedByPriority() {

			let events = [], vm = this
			this.scheduleEvents.forEach(event => {
				events.push(this.renderEventObj(event))
			})

			return events.sort((a,b) => {
				if (a.startMoment.isSame(b.startMoment) && a.priority_index < b.priority_index)
					return -1
				else if (a.startMoment.isSame(b.startMoment) && a.priority_index > b.priority_index)
					return 1
				else if (a.startMoment.isBefore(b.startMoment))
					return -1

				return 1
			})
		}
	},
	methods: {
		initFilteringValues() {
			let vm = this

			Object.keys(this.filtering).forEach(key => {
				vm[key] = vm.filtering[key]
			})

			this.setEventDayVModels()
		},
		gridViewDraggableClasses(day) {
			let classes = "day "

			if (day.format('dd') == 'Su' || day.format('dd') == 'Sa')
				classes += "weekend-day "

			classes += "day-of-"+day.format("YYYY-MM-DD")

			return classes
		},
		getHoursScheduled(row) {
			if (!("items" in row))
				return 0

			let total = row.items.reduce((acc,item) => {
				//calc duratino in hours from start to end
				return acc + item.endMoment.diff(item.startMoment,"hours")
			},0)

			return total.toFixed(1)
		},
		setEventDayVModels() {
			let vm = this
			vm.eventDayVModels = []
			vm.eventDayVModelsOldState = []
			this.week.forEach((day,dayIndex) => {

				let events = vm.filterScheduleEvents(vm.sortEventsToEntityTypesAndPriority(this.scheduleEvents).filter(item => item.startMoment.format('dd') == day.format('dd')))

				vm.eventDayVModels.push(events)
				vm.eventDayVModelsOldState.push(events)
			})

		},
		dayClick(dayMoment) {
			this.$emit('dayClick',dayMoment.format("YYYY-MM-DD"))
		},
		itemClick(item) {
			this.$emit("itemClick",item)
		},
		dragEnd(arg,items,fromDayIndex) {
			let vm = this

			let theItem = vm.eventDayVModelsOldState[fromDayIndex][arg.oldIndex]

			console.log(theItem)


			let fromClass = Array.from(arg.from.classList).find(cl => cl.search("day-of-") >= 0)
			let toClass = Array.from(arg.to.classList).find(cl => cl.search("day-of-") >= 0)

			let fromDate = this.moment(fromClass.replace("day-of-",""))
			let toDate = this.moment(toClass.replace("day-of-",""))

			//keeping the same time, swap "from" date to "to" date by finding the difference in days between from and to, and adding that to the old startMoment/endMoment

			let diffInDays = toDate.diff(fromDate,"days")

			let diffInHours = diffInDays * 24

			let start_time = theItem.startMoment.add(diffInHours,"hours").utc().format("YYYY-MM-DD HH:mm:ss")
			let end_time = theItem.endMoment.add(diffInHours,"hours").utc().format("YYYY-MM-DD HH:mm:ss")

			let theItemPayload = {
				id: theItem.id,
				start_time,
				end_time,
				repeat_until: end_time,
				priority_index: arg.newIndex
			}

			//find day index of destination
			let toDayIndex = toDate.day()

			let promises = []

			//re-save all items in list with new indexes
			
			
			vm.eventDayVModels[fromDayIndex].forEach((item, itemIndex) => {

				let newPriorityIndex = itemIndex + 1

				if (item.id == theItem.id) {
					promises.push(vm.postData("ScheduleEvent/save",theItemPayload,true))
				}
				else {
					let payload = {
						id: item.id,
						priority_index: itemIndex
					}

					promises.push(vm.postData("ScheduleEvent/save",payload))
				}
				
			})

			if (toDayIndex != fromDayIndex) {
				//also save the new day indexes if the event has been moved to a new day
				vm.eventDayVModels[toDayIndex].forEach((item, itemIndex) => {

					let newPriorityIndex = itemIndex + 1

					if (item.id == theItem.id) {
						promises.push(vm.postData("ScheduleEvent/save",theItemPayload,true))
					}
					else {
						let payload = {
							id: item.id,
							priority_index: itemIndex
						}

						promises.push(vm.postData("ScheduleEvent/save",payload))
					}
					
				})
			}

			Promise.all(promises).then(responses => {
				if (responses[0].success) 
					vm.alertSaved("Event rescheduled")

				vm.setEventDayVModels()
				vm.$emit('refresh')
			})
			
		}
	},
	created() {
		this.initFilteringValues()
		this.setEventDayVModels()
	}
}
</script>

<style type="text/css" scoped>

.weekly-view {
	width: 100%;
	table-layout: fixed;
}

.weekly-view thead {
	width: 100%;
}

.weekly-view thead th {
	
	padding: 10px;
	text-align: center;
}

.days-axis .day {
	border-bottom: none;
	text-align: center;
	width: 12.5%;
	max-width: 12.5%;
	background-color: var(--background-menus);
	cursor: pointer;
	padding: 0;
	border-top: 1px solid gray;
	font-weight: normal;
	color: white;
}

.days-axis .day:hover {
	background-color: var(--brand-primary-color-translucent);
}

.days-axis .day.weekend-day {
	color: #99d4dd;
}

.row-label {
	font-weight: normal;
}

.weekly-view tr {
	border-bottom: 1px solid gray;
}

.scheduled-item-row.project-row .scheduled-item {
	background-color: #7c61f31c;
}

.scheduled-item-row.service-row .scheduled-item {
	background-color: #61f3af1c;
}

.day-container {
	width: 12.5%;
	position: relative;
}

.scheduled-item {
	align-items: center;
	background-color: #fff;
	border: 1px solid rgba(0,0,0,.125);
	border-radius: 4px;
	color: #495057;
	padding: 8px;
	width: 100%;
	background-color: var(--background-light);
	border-radius: 4px;
	font-size: 9pt;
	cursor: pointer;
	height: 100%;
	overflow: hidden;
	white-space: nowrap;
	/*
	position: absolute;
	top: 0;
	left: 0;
	*/

}

.scheduled-item.event-continued {
	border-left: none;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

</style>